import { render } from "./DeleteIcon.vue?vue&type=template&id=08e4be8e"
const script = {}

import exportComponent from "E:\\TestProject Temurako\\e-commerce-app-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__